export default {
  BusinessStockSynchronizationAdd: {
    title: 'Account Information',
    titleBtn: 'Select Logical Warehouse',
    code: 'Logical Data Sync Number',
    codeText: 'System Generated',
    logicBinCode: 'Logical Warehouse Code',
    codeSelect: 'Please select a logical warehouse',
    name: 'Logical Warehouse Name',
    nameText: 'Please select a logical warehouse',
    commodityDetails: 'Product Details',
    selectProduct: 'Select Product',
    delProduct: 'Delete Product',
    num: 'Adjust Quantity Difference',
    msgWarning1: 'Please select a logical warehouse first',
    msgWarning2: 'Please select a product first',
    msgWarning3: 'Please complete the Adjustment Type and Difference Quantity (cannot be 0)',
  }
};
